/**
 * Featured Products Cards — behavior
 *
 * Pack of 1 / 2 / 3 = QUANTITY of the same variant (no separate variants).
 * Add to Cart uses AJAX (no redirect to /cart) and refreshes the Dawn-style
 * cart drawer in place so the item shows up without a page refresh.
 *
 * Open DevTools console and watch for "[FPC]" lines to debug.
 */
(function () {
  "use strict";

  var LOG_PREFIX = "[FPC]";
  function log()  { console.log.apply(console, [LOG_PREFIX].concat(Array.prototype.slice.call(arguments))); }
  function warn() { console.warn.apply(console, [LOG_PREFIX].concat(Array.prototype.slice.call(arguments))); }
  function err()  { console.error.apply(console, [LOG_PREFIX].concat(Array.prototype.slice.call(arguments))); }

  function getCardRoot(el) {
    return el.closest(".fpc-card");
  }

  /* ---------------------------------------------------------
     PACK SELECTOR -> quantity input (same variant, no variant swap)
  --------------------------------------------------------- */
  function syncQuantity(select) {
    var card = getCardRoot(select);
    if (!card) {
      warn("Pack select changed but no parent .fpc-card found for:", select);
      return;
    }
    var qtyInput = card.querySelector('.fpc-atc-form input[name="quantity"]');
    var qty = parseInt(select.value, 10);
    if (!qty || qty < 1) qty = 1;

    log("Pack changed ->", select.options[select.selectedIndex].textContent.trim(), "| quantity ->", qty);

    if (!qtyInput) {
      err("Could not find quantity input inside this card's .fpc-atc-form.");
      return;
    }
    qtyInput.value = qty;
    log("Quantity input updated ->", qtyInput.value);
  }

  function syncAllPackSelectors(root) {
    var scope = root || document;
    var selects = scope.querySelectorAll(".fpc-pack-select");
    log("Initializing", selects.length, "pack selector(s).");
    for (var i = 0; i < selects.length; i++) {
      syncQuantity(selects[i]);
    }
  }

  document.addEventListener("change", function (e) {
    var select = e.target.closest(".fpc-pack-select");
    if (!select) return;
    syncQuantity(select);
  });

  /* ---------------------------------------------------------
     ADD TO CART (AJAX)
  --------------------------------------------------------- */
  function setButtonState(btn, state, labels) {
    if (!btn) return;
    if (!btn.dataset.originalText) {
      btn.dataset.originalText = btn.textContent.trim();
    }
    if (state === "loading") {
      btn.disabled = true;
      btn.textContent = labels.loading;
    } else if (state === "added") {
      btn.disabled = false;
      btn.textContent = labels.added;
      setTimeout(function () { btn.textContent = btn.dataset.originalText; }, 1800);
    } else if (state === "error") {
      btn.disabled = false;
      btn.textContent = labels.error;
      setTimeout(function () { btn.textContent = btn.dataset.originalText; }, 2200);
    } else {
      btn.disabled = false;
      btn.textContent = btn.dataset.originalText;
    }
  }

  function shopifyRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  }

  /* Parse an HTML string and pull out the element matching `selector`. */
  function extractFromHtml(html, selector) {
    var doc = new DOMParser().parseFromString(html, "text/html");
    return doc.querySelector(selector);
  }

  /* Update a live element's *contents* in place (keeps the same DOM node,
     so any listeners/references your theme already attached still work). */
  function swapInnerHtml(liveEl, newEl) {
    if (!liveEl || !newEl) return false;
    liveEl.innerHTML = newEl.innerHTML;
    // carry over any state classes (e.g. Dawn's "is-empty") from the fresh render
    liveEl.className = newEl.className;
    return true;
  }

  // Known Dawn-style targets: [section handle requested, live selector]
  var DRAWER_TARGETS = [
    { section: "cart-drawer", live: "cart-drawer, #CartDrawer" },
    { section: "cart-notification", live: "cart-notification, #cart-notification" },
    { section: "cart-icon-bubble", live: "#cart-icon-bubble" }
  ];

  function refreshDrawerFromSections(sections) {
    if (!sections) {
      warn("No 'sections' object in the add-to-cart response — theme may use different section handles.");
      return false;
    }
    var anyUpdated = false;
    DRAWER_TARGETS.forEach(function (target) {
      var html = sections[target.section];
      if (!html) return; // this handle wasn't returned / doesn't exist on this theme
      var liveEl = document.querySelector(target.live);
      if (!liveEl) {
        warn("Got section HTML for '" + target.section + "' but no matching live element (" + target.live + ") on the page.");
        return;
      }
      var newEl = extractFromHtml(html, target.live);
      if (!newEl) {
        warn("Section '" + target.section + "' HTML did not contain a matching element for selector:", target.live);
        return;
      }
      log("Refreshing drawer content from section:", target.section);
      swapInnerHtml(liveEl, newEl);
      anyUpdated = true;
    });
    return anyUpdated;
  }

  function tryOpenCartDrawer(selectorList) {
    if (!selectorList) return false;
    var selectors = selectorList.split(",").map(function (s) { return s.trim(); }).filter(Boolean);
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) {
        log("Clicking cart drawer trigger:", selectors[i]);
        el.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true }));
        return true;
      }
    }
    warn("No cart drawer trigger matched:", selectorList);
    return false;
  }

  function notifyThemeCartUpdated(cartData) {
    document.dispatchEvent(new CustomEvent("cart:refresh", { detail: cartData }));
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: cartData }));
    document.dispatchEvent(new CustomEvent("ajaxProduct:added", { detail: cartData }));
    document.documentElement.dispatchEvent(new CustomEvent("fpc:added-to-cart", { detail: cartData, bubbles: true }));
  }

  document.addEventListener("submit", function (e) {
    var form = e.target.closest(".fpc-atc-form");
    if (!form) return;

    log("Add to cart form submitted.");

    var section = form.closest(".fpc-section");
    var ajaxDisabled = section && section.dataset.ajaxCart === "false";
    if (ajaxDisabled) {
      log("AJAX add-to-cart disabled in section settings — using native form submit.");
      return;
    }

    e.preventDefault();

    var qtyInput = form.querySelector('input[name="quantity"]');
    log("Submitting variant:", form.querySelector('input[name="id"]').value, "| quantity:", qtyInput ? qtyInput.value : 1);

    var btn = form.querySelector(".fpc-atc-btn");
    var labels = {
      loading: (section && section.dataset.labelAdding) || "Adding...",
      added: (section && section.dataset.labelAdded) || "Added",
      error: (section && section.dataset.labelError) || "Couldn't add"
    };

    setButtonState(btn, "loading", labels);

    // Wait a tick before reading the form's data. This gives any other
    // "submit" listeners attached to this same form/document — e.g. a
    // discount or bundle app that injects hidden line-item properties
    // such as `_deal_block` — a chance to run and modify the form first.
    // Without this delay, we could capture a snapshot of the form BEFORE
    // those listeners have a chance to add their properties, which would
    // mean the item gets added without the tag the discount app relies on.
    setTimeout(function () {
      var formData = new FormData(form);
      // Ask Shopify to render the drawer/notification/bubble sections in this
      // same response, so we can refresh them without a second round trip.
      formData.append("sections", "cart-drawer,cart-notification,cart-icon-bubble");
      formData.append("sections_url", window.location.pathname);

      fetch(shopifyRoot() + "cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData
      })
        .then(function (res) {
          return res.json().then(function (data) {
            log("cart/add.js response (status " + res.status + "):", data);
            if (!res.ok) {
              var e2 = new Error((data && data.description) || "Add to cart failed");
              e2.data = data;
              throw e2;
            }
            return data;
          });
        })
        .then(function (addedItem) {
          log("Item added:", addedItem.title, "| qty:", addedItem.quantity);
          setButtonState(btn, "added", labels);

          var updated = refreshDrawerFromSections(addedItem.sections);

          return fetch(shopifyRoot() + "cart.js")
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              log("Current cart after add:", cart);
              notifyThemeCartUpdated(cart);

              var drawerSelectors = (section && section.dataset.cartDrawerSelector) || "";
              var opened = tryOpenCartDrawer(drawerSelectors);

              if (!updated) {
                warn("Drawer HTML could not be auto-refreshed via sections. It may still open with stale content.");
              }
              if (!opened && section && section.dataset.redirectToCart === "true") {
                log("No drawer trigger found — redirecting to /cart as configured.");
                window.location.href = shopifyRoot() + "cart";
              }
            });
        })
        .catch(function (e3) {
          err("Add to cart error:", e3, e3 && e3.data);
          setButtonState(btn, "error", labels);
        });
    }, 0);
  });

  /* ---------------------------------------------------------
     INIT
  --------------------------------------------------------- */
  function init() {
    log("Script loaded.");
    syncAllPackSelectors(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function (e) {
    log("Theme editor re-rendered a section — re-syncing pack selectors.");
    syncAllPackSelectors(e.target);
  });
})();